import styled from 'styled-components';

export const SupportContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  background: white;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  line-height: 1.6;
  color: #333;

  h1 {
    color: #2c3e50;
    margin-bottom: 30px;
    font-size: 2.8em;
    text-align: center;
    background: linear-gradient(135deg, #ff8c42 0%, #ff6b35 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  h2 {
    color: #34495e;
    margin-top: 40px;
    margin-bottom: 20px;
    font-size: 1.8em;
    border-bottom: 2px solid #fff5f0;
    padding-bottom: 10px;
  }

  h3 {
    color: #2c3e50;
    margin-top: 25px;
    margin-bottom: 15px;
    font-size: 1.3em;
  }

  p {
    margin-bottom: 15px;
    color: #5a6c7d;
  }

  @media (max-width: 768px) {
    padding: 20px 15px;
    h1 {
      font-size: 2em;
    }
  }
`;

export const SupportGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 30px;
`;

export const SupportCard = styled.div`
  background: #fff;
  padding: 25px;
  border-radius: 16px;
  border: 1px solid #feece2;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(255, 140, 66, 0.1);
    border-color: #ff8c42;
  }

  .icon {
    font-size: 2em;
    margin-bottom: 15px;
    display: block;
  }

  h3 {
    margin-top: 0;
    margin-bottom: 10px;
    color: #ff8c42;
  }

  p {
    font-size: 0.95em;
    margin-bottom: 0;
  }
`;

export const ContactSection = styled.div`
  margin-top: 60px;
  padding: 40px;
  background: linear-gradient(135deg, #fff5f0 0%, #fff 100%);
  border-radius: 20px;
  text-align: center;
  border: 1px solid #feece2;

  h2 {
    margin-top: 0;
    border: none;
  }

  .contact-methods {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-top: 30px;
    flex-wrap: wrap;
  }

  .method {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    span {
      font-weight: 600;
      color: #2c3e50;
    }

    a {
      color: #ff8c42;
      text-decoration: none;
      font-size: 1.1em;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const FaqSection = styled.div`
  margin-top: 60px;
`;

export const FaqItem = styled.div`
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;

  h4 {
    color: #2c3e50;
    font-size: 1.1em;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;

    &::before {
      content: 'Q:';
      color: #ff8c42;
      font-weight: 800;
    }
  }

  p {
    padding-left: 25px;
    font-size: 0.95em;
    position: relative;

    &::before {
      content: 'A:';
      position: absolute;
      left: 0;
      color: #7f8c8d;
      font-weight: 600;
    }
  }
`;
